import { render, staticRenderFns } from "./ExpenseHandler.vue?vue&type=template&id=2e4877e6"
import script from "./ExpenseHandler.vue?vue&type=script&lang=js"
export * from "./ExpenseHandler.vue?vue&type=script&lang=js"
import style0 from "./ExpenseHandler.vue?vue&type=style&index=0&id=2e4877e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports